import './ImageTextBlock.scss'

import React from 'react'
import {ImageType, LinkType, WysiwygType} from '../../types'
import {style} from '../../util/style'
import {Theme} from '../../views/Theme'
import {Picture} from '../ui/Picture'
import {Video} from '../ui/Video'
import {Block} from './Blocks'
import {ImagesBlockCaption} from './ImagesBlock'

const styles = style('imagetextblock')

export type ImageTextBlockType = {
	media_type?: 'image' | 'video'
	media_position?: 'left' | 'right'
	image?: ImageType
	video?: string
	cookie_services?: Array<{id: number}>
	text?: WysiwygType
	button?: LinkType
}

export const ImageTextBlock: React.FC<
	ImageTextBlockType & {container?: boolean}
> = ({
	container,
	media_type = 'image',
	media_position = 'left',
	image,
	video,
	cookie_services,
	text,
	button
}) => {
	if (!image && !video) return null

	return (
		<Block className={styles().mod(media_position)} container={container}>
			<div className={styles('row')}>
				<div className={styles('row-media')}>
					{(media_type === 'image' || (media_type === 'video' && !video)) &&
						image && (
							<figure className={styles('row-media-image')}>
								<Picture {...image} />
								<ImagesBlockCaption caption={image?.meta?.caption} />
							</figure>
						)}
					{media_type === 'video' && video && (
						<Video video={video} cookie_services={cookie_services} />
					)}
				</div>
				<div className={styles('row-content')}>
					{text && <Theme.Wysiwyg>{text}</Theme.Wysiwyg>}
					{button?.url && (
						<div className={styles('row-content-button')}>
							<Theme.Button to={button.url}>
								{button.description || button.title}
							</Theme.Button>
						</div>
					)}
				</div>
			</div>
		</Block>
	)
}
